import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getTranslationAxios() // eslint-disable-line
const axiosStConfigInstance = axios.getSTAxios() // eslint-disable-line

export default {

  translateString (options) {
    return new Promise((resolve, reject) => {
      axiosInstance.post('/translate', { source_language: options.source, destination_languages: options.destinations, text: options.text }).then((res) => {
        res.data.key = options.key
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  translateStringArray (options) {
    // console.log(options.keys)
    // console.log('!!!')
    // const keys = []
    // for (const [key] of Object.entries(options.keys)) {
    //   // promiseArray.push(TranslationService.translateString({ destinations: destinations, source, text: strings[key], key }))
    //   keys.push(key)
    // }
    // console.log('k', keys)
    return new Promise((resolve, reject) => {
      axiosInstance.post('/translate', { source_language: options.source, destination_languages: options.destinations, text: options.text }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async loadCompanyLanguages () {
    return new Promise((resolve, reject) => {
      axiosStConfigInstance.get('/translate/languages/').then((res) => {
        resolve(res.data?.iso_codes || [])
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
